import type { AccountLicense as AccountLicenseModel } from '@/adapters/catalogv1.g';

export function extractAccountLicense(model: AccountLicenseModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    licenseRef: model.license_ref ?? '',
    disabledServicePlans: model.disabled_service_plans,
    enabledServicePlans: model.enabled_service_plans,
    assignedVia: model.assigned_via ?? '',
    sourceGroupRef: model.source_group_ref ?? '',
    status: model.status ?? '',
    statusError: model.status_error ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountLicense = ReturnType<typeof extractAccountLicense>;
